import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/site/BlogPreview.css';

const BlogPreview = ({ postsCount = 3 }) => {
  // Função helper para construir a URL da imagem
  const getImageUrl = (path) => {
    return `${process.env.PUBLIC_URL}${path}`;
  };

  // Em produção, estes dados viriam de uma API
  const blogPosts = [
    {
      id: 1,
      title: "Como a Astrologia pode transformar seu autoconhecimento",
      excerpt: "Descubra como os astros podem revelar aspectos profundos da sua personalidade e ajudar no seu desenvolvimento pessoal.",
      imagePath: "/images/site/blogexemplo.svg",
      category: "Autoconhecimento",
      date: "12 Abr 2023",
      slug: "como-astrologia-pode-transformar-autoconhecimento"
    },
    {
      id: 2,
      title: "Os trânsitos de 2023 e seu impacto nos relacionamentos",
      excerpt: "Entenda como os movimentos planetários deste ano influenciam suas relações e como tirar o melhor proveito destas energias.",
      imagePath: "/images/site/blogexemplo.svg",
      category: "Relacionamentos",
      date: "28 Mar 2023",
      slug: "transitos-2023-impacto-relacionamentos"
    },
    {
      id: 3,
      title: "Como interpretar a Lua no seu mapa astral",
      excerpt: "A Lua representa nossas emoções e necessidades mais profundas. Aprenda a decifrar seu significado no seu mapa natal.",
      imagePath: "/images/site/blogexemplo.svg",
      category: "Mapa Astral",
      date: "15 Mar 2023",
      slug: "como-interpretar-lua-mapa-astral"
    }
  ];

  // Limitar o número de posts exibidos
  const limitedPosts = blogPosts.slice(0, postsCount);

  return (
    <section className="blog-preview-section">
      <div className="container">
        {/* Resto do JSX permanece o mesmo */}
        <div className="section-header">
          <h2 className="section-title">Blog Astrológico</h2>
          <div className="divider">
            <span className="star-divider">✧</span>
          </div>
        </div>

        <div className="blog-preview-grid">
          {limitedPosts.map(post => (
            <article key={post.id} className="blog-card">
              <div className="blog-card-image">
                <Link to={`/blog/${post.slug}`}>
                  <img src={getImageUrl(post.imagePath)} alt={post.title} />
                </Link>
                <span className="blog-category">{post.category}</span>
              </div>
              
              {/* Resto do JSX para card permanece o mesmo */}
              <div className="blog-card-content">
                <div className="blog-meta">
                  <span className="blog-date">
                    <i className="far fa-calendar"></i> {post.date}
                  </span>
                </div>
                
                <h3 className="blog-title">
                  <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                </h3>
                
                <p className="blog-excerpt">{post.excerpt}</p>
                
                <Link to={`/blog/${post.slug}`} className="read-more">
                  Ler mais <i className="fas fa-long-arrow-alt-right"></i>
                </Link>
              </div>
            </article>
          ))}
        </div>

        <div className="view-all-container">
          <Link to="/blog" className="btn btn-outline">
            Ver todos os artigos
          </Link>
        </div>
      </div>
    </section>
  );
};

export default BlogPreview;